module.exports = __webpack_public_path__ + "static/img/BannerHome.a86def25.png";